export default "__VITE_ASSET__DjYVcpva__"